"use client"

import { useFcmToken } from "@/hooks/use-fcm-token"
import { usePrivy } from "@privy-io/react-auth"

/**
 * FcmRegistrar — mounts the FCM token hook for authenticated users.
 * Renders nothing; only runs the side-effect of registering the push token
 * and opening the real-time signal WebSocket.
 */
export function FcmRegistrar() {
  const { authenticated, user } = usePrivy()
  useFcmToken(authenticated, user?.id ?? null)
  return null
}
